<template>
  <van-calendar
    v-model="show"
    @confirm="handleConfirm"
    :formatter="formatCalendar"
    :show-confirm="false"
    :title="title"
    :default-date="defaultDate"
    :min-date="minDate"
    v-bind="$attrs"
  />
</template>

<script>
import moment from "moment";
import calendar from "@/js/date";
export default {
  name: "Calendar",
  props: {
    minDate: {
      typeof: Date,
      default: () => new Date(moment().add(-1, "y")),
    },
    defaultDate: {
      typeof: Array,
      default: () => [new Date(), new Date()],
    },
    title: {
      typeof: String,
      default: "日期选择(仅可查询1年内)",
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    /**
     * 日历选择确认函数
     * @param {*} e
     */
    handleConfirm(e) {
      this.$emit("confirm", e);
      this.show = false;
    },
    /**
     * 日历格式化函数
     * @param {*} day(
     */
    formatCalendar(day) {
      const date = day.date;
      const lunar = calendar.solar2lunar(
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()
      );
      day.bottomInfo = lunar.festival || lunar.Term || lunar.IDayCn;

      if (lunar.nWeek == 6 || lunar.nWeek == 7) {
        day.className = "weekday";
      }
      return day;
    },
  },
};
</script>

<style>
</style>